// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
import { AccessToHallRestricted } from './access-to-hall-restricted'

const COMPONENT_ID = 'accessToHallRestrictedBecauseOfPayment'

type ShowAccessToHallRestrictedProps = Omit<
  Parameters<typeof AccessToHallRestricted>[0],
  'isOpen' | 'onClose'
>

export const showAccessToHallRestrictedBecauseOfPaymentModal = (
  props: ShowAccessToHallRestrictedProps,
) => addModal({ id: COMPONENT_ID, props })

export default {
  [COMPONENT_ID]: {
    Component: AccessToHallRestricted,
  },
}
